/**
 * TabsStore - сховище для управління станом табів
 * 
 * Розширює UIManager і забезпечує керування станом табів через MobX
 */

import { UIManager } from '@/Core/Managers/UI/UIManager'
import type { IUIManagerConfig } from '@/Core/Contracts/UI/UIManager'
import { action, makeObservable, observable } from 'mobx'
import type { TabItem } from '../Tabs.types'

interface TabsStoreConfig extends IUIManagerConfig {
    items?: TabItem[]
    activeKey?: string
    defaultActiveKey?: string
    type?: 'line' | 'card' | 'editable-card'
    size?: 'small' | 'middle' | 'large'
}

export class TabsStore extends UIManager {
    items: TabItem[] = []
    activeKey?: string
    defaultActiveKey?: string
    type: 'line' | 'card' | 'editable-card' = 'line'
    size: 'small' | 'middle' | 'large' = 'middle'

    constructor({
        items,
        activeKey,
        defaultActiveKey,
        type,
        size,
        ...props
    }: TabsStoreConfig = {}) {
        super(props)

        if (Array.isArray(items)) this.items = items
        if (activeKey) this.activeKey = activeKey
        if (defaultActiveKey) this.defaultActiveKey = defaultActiveKey
        if (type) this.type = type
        if (size) this.size = size

        makeObservable(this, {
            items: observable,
            activeKey: observable,
            type: observable,
            size: observable,
            setItems: action,
            setActiveKey: action,
        })
    }

    setItems(items: TabItem[]): void {
        this.items = items
    }

    setActiveKey(key: string): void {
        this.activeKey = key
    }
}
